import { render, staticRenderFns } from "./ActionShow.vue?vue&type=template&id=0b589ed8&"
import script from "./ActionShow.vue?vue&type=script&lang=js&"
export * from "./ActionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports